import type { ListCreatorDiscoverySearchResultsRequest, ListDiscoveryMessagesRequest } from './api';

export const discoveryQueryKeys = {
  all: (workspaceId: string) => [workspaceId, 'discovery'] as const,
  currentSession: (workspaceId: string) => [workspaceId, 'discovery', 'current-session'] as const,
  messagesRoot: (workspaceId: string, sessionId: string) =>
    [workspaceId, 'discovery', 'messages', sessionId] as const,
  messages: (workspaceId: string, sessionId: string, request?: ListDiscoveryMessagesRequest) =>
    request == null
      ? ([workspaceId, 'discovery', 'messages', sessionId] as const)
      : ([
          workspaceId,
          'discovery',
          'messages',
          sessionId,
          'limit',
          request.limit ?? null,
          'cursor',
          request.cursor ?? null,
        ] as const),
  searches: (workspaceId: string) => [workspaceId, 'discovery', 'search'] as const,
  searchStatus: (workspaceId: string, sessionId: string, searchId: string) =>
    [workspaceId, 'discovery', 'search', sessionId, searchId, 'status'] as const,
  searchResults: (
    workspaceId: string,
    sessionId: string,
    searchId: string,
    request: Omit<ListCreatorDiscoverySearchResultsRequest, 'attempt'>,
  ) =>
    [
      workspaceId,
      'discovery',
      'search',
      sessionId,
      searchId,
      'results',
      'show_saved',
      request.show_saved ?? null,
    ] as const,
};
